<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/Page-header";

/**
 * Starter component
 */
export default {
  head () {
    return {
      title: `${this.title} | Minton - Nuxtjs Responsive Admin Dashboard Template`,
    };
  },
  data () {
    return {
      title: "單元答題紀錄",
      items: [
        {
          text: "法語鸚鵡螺",
          href: "/",
        },
        {
          text: "單元答題紀錄",
          active: true,
        }
      ],
      pluginItem: {
        title: '',
        des: ''
      },
      currentPage: 1,
      totalRows: 1,
      perPgae: 15,
      searchEmail: "",
      unitRecords: []
    };
  },
  components: {
    Layout,
    PageHeader,
  },
  created () {
    this.getUnitRecordList()
  },
  watch: {
    currentPage (_page) {
      this.getUnitRecordList()
    }
  },
  methods: {
    getUnitRecordList () {
      this.$root.apis.getUnitRecordList(this.currentPage, this.processSearchUnitRecordList)
    },
    processSearchUnitRecordList (_response) {
      this.unitRecords = _response.body.items
      this.currentPage = _response.body.page
      this.totalRows = _response.body.total
      this.perPgae = _response.body.per_page
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <!-- <div class="row">
      <div class="col-lg-12 col-xl-12">
        <b-card>
          <div class="row">
            <div class="col-9">
              <div class="form-group">
                <label for="field-2" class="control-label">Email</label>
                <input class="form-control" placeholder="請輸入用戶 Emaii" v-model="searchEmail" />
              </div>

            </div>
            <div class="col-3 text-right pt-3">
              <b-button variant="primary" type="button" @click="getMemberRecordList">查詢</b-button>
            </div>
          </div>

        </b-card>
      </div>
    </div> -->

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-borderless mb-0">
                <thead class="thead-light">
                  <tr class="text-center">
                    <th>項次</th>
                    <th>單元名稱</th>
                    <th>答題次數</th>
                    <th>總平均分數</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody v-if="!unitRecords.length">
                  <tr>
                    <td colspan="9" class="text-center">無資料</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr v-for="(record, index) in unitRecords">
                    <td class="text-center">{{ (index + 1) }}</td>
                    <td class="text-left"> {{ record.title ?? '-' }} </td>
                    <td class="text-center"> {{ record.anser_counts ?? '-' }} </td>
                    <td class="text-center"> {{ record.anser_avg ?? '-' }} </td>
                    <td class="text-center">
                      <b-button size="sm" variant="primary"
                        @click="$router.push('/users/records/unit/item/' + record.id)">查看</b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded">
            <!-- pagination -->
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPgae"></b-pagination>
          </ul>
        </div>
      </div>
    </div>

  </Layout>
</template>
